import api from "@/libs/axios";
import * as ep from "./endpoints";

export default {
  namespaced: true,
  state: () => ({
    categories: [],
    question: [],
    loading: false,
    loadingCat: false,
  }),
  getters: {
    question(state) {
      return state.question;
    },
    categories(state) {
      return state.categories;
    },
    loading(state) {
      return state.loading;
    },
    loadingCat(state) {
      return state.loadingCat;
    },
  },
  mutations: {
    setQuestion(state, payload) {
      state.question = payload;
    },
    setCategories(state, payload) {
      state.categories = payload;
    },
  },
  actions: {
    async getQuestion(context, payload) {
      context.state.loading = true;
      await api.get(ep.faqQuestion(payload.id)).then((res) => {
        context.commit("setQuestion", res.data.data);
        context.state.loading = false;
      });
    },

    async getCategories(context) {
      context.state.loadingCat = true;
      await api.get(ep.faq_categories).then((res) => {
        context.commit("setCategories", res.data.data);
        context.state.loadingCat = false;
      });
    },

    async filteredQuestion(context, payload) {
      context.state.loadingCat = true;
      await api.get(ep.filterQuestion, { params: payload }).then((res) => {
        context.commit("setQuestion", res.data.data);
        context.state.loadingCat = false;
      });
    },
  },
};
